module.exports = __webpack_public_path__ + "023ba715.webp";